export const DEFAULT_PAGE_SIZE = 100;
export const PAGE_SIZE_OPTIONS = ['20', '50', '100'];
